import { ArrowRight } from 'lucide-react';
import { contactActions, libraryResources, pathCards, pillars, shopUrl } from '../../lib/content';
import { MysticOrb } from '../components/MysticOrb';
import { StarField } from '../components/StarField';
import { PublicLayout } from '../PublicLayout';

export function HomePage() {
  return (
    <PublicLayout>
      <main id="top">
        <section className="hero-section">
          <StarField />
          <div className="hero-copy">
            <p className="eyebrow">Experience - Transformation - Unity</p>
            <h1>Society of Mystics</h1>
            <p className="hero-lead">
              A modern sanctuary for seekers drawn to direct experience, interfaith understanding, personal transformation,
              and the mystery already resonating within them.
            </p>
            <div className="hero-actions">
              <a className="button-primary" href="#start-here">
                Start Here <ArrowRight size={18} />
              </a>
              <a className="button-secondary" href="#library">
                Explore Library
              </a>
              <a className="button-ghost" href={shopUrl}>
                Shop
              </a>
            </div>
          </div>
          <MysticOrb />
        </section>

        <section id="about" className="content-band">
          <div className="wrap split">
            <div>
              <p className="eyebrow">About</p>
              <h2>All Are Welcome Here</h2>
            </div>
            <div className="prose">
              <p>
                The Society of Mystics seeks to unite seekers from diverse backgrounds and traditions in the pursuit of
                deeper understanding and connection with the mysteries of existence.
              </p>
              <p>
                Mysticism is approached here through direct experience rather than dogma. The path is not a guru-led
                system; it is a lantern for solo cultivation, recognition, and embodied practice.
              </p>
            </div>
          </div>
        </section>

        <section className="content-band dark">
          <div className="wrap">
            <div className="section-head">
              <p className="eyebrow">Four Pillars</p>
              <h2>The Four Pillars</h2>
            </div>
            <div className="pillar-grid">
              {pillars.map((pillar) => {
                const Icon = pillar.icon;
                return (
                  <article className="pillar-card" key={pillar.title}>
                    <Icon size={28} />
                    <h3>{pillar.title}</h3>
                    <p>{pillar.description}</p>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        <section id="start-here" className="content-band">
          <div className="wrap">
            <div className="section-head">
              <p className="eyebrow">Start Here</p>
              <h2>Are You a Mystic?</h2>
              <p>
                A mystic is not defined by a title. The signal is a hunger for direct knowing, unity, compassion, and
                honest exploration of the inner world.
              </p>
            </div>
            <div className="path-grid">
              {pathCards.map((card) => {
                const Icon = card.icon;
                return (
                  <article className="path-card" key={card.title}>
                    <span>{card.eyebrow}</span>
                    <Icon size={24} />
                    <h3>{card.title}</h3>
                    <p>{card.description}</p>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        <section id="library" className="content-band dark">
          <div className="wrap">
            <div className="section-head">
              <p className="eyebrow">Suggested Reading</p>
              <h2>Library</h2>
              <p>
                The resource library will hold reading lists, practice references, and downloadable PDFs served through
                Cloudflare R2.
              </p>
            </div>
            <div className="resource-list">
              {libraryResources.map((resource) => (
                <article className="resource-row" key={resource.title}>
                  <span>{resource.type}</span>
                  <div>
                    <h3>{resource.title}</h3>
                    <p>{resource.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="join" className="join-section">
          <div className="wrap join-panel">
            <p className="eyebrow">Join Us</p>
            <h2>Join Us on the Journey</h2>
            <p>
              Explore the mystery within. Build unity without. The Society is the house for the Enmyo Path, the Kuon
              Method, contemplative study, and resources for modern solo cultivation.
            </p>
            <div className="hero-actions">
              {contactActions.map((action) => {
                const Icon = action.icon;
                return (
                  <a className="button-primary" href={action.href} key={action.label}>
                    {action.label} <Icon size={18} />
                  </a>
                );
              })}
            </div>
          </div>
        </section>

        <section id="contact" className="content-band">
          <div className="wrap contact-grid">
            <div>
              <p className="eyebrow">Contact</p>
              <h2>Begin the conversation</h2>
              <p>
                Contact submissions will be stored through the Cloudflare backend for review in the admin area. Email
                remains available as a direct fallback.
              </p>
            </div>
            <form className="contact-form">
              <input name="name" placeholder="Name" autoComplete="name" />
              <input name="email" placeholder="Email" type="email" autoComplete="email" />
              <textarea name="message" placeholder="What are you seeking?" />
              <button className="button-primary" type="button">
                Send Inquiry
              </button>
            </form>
          </div>
        </section>
      </main>
    </PublicLayout>
  );
}
